import auth0Events from "./auth0Events.json";

export const getEventFromEventCode = (code) => {
  return auth0Events.find((event) => event.eventCode === code);
};
